import { RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getNumberValue, getObjectValue } from 'utilities';
import { RangeSensitivityReverseParserParams } from './types';

const customReverseParser = (params: RangeSensitivityReverseParserParams) => {
  const { cells, rangeSensitivity } = getObjectValue(params);
  // Keep the original object reference so workbook reverse parsing updates
  // the same range_sensitivities entry consumed by the valuation save payload.
  const updatedRangeSensitivity = rangeSensitivity;

  Object.values(getObjectValue(cells)).forEach(cell => {
    const { alias } = getObjectValue(cell);

    if (alias === RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER && cell.columnLegend === 'A') {
      const raw = getNumberValue(cell.value as number | string | null | undefined);
      updatedRangeSensitivity.sensitivity_percentage = String(raw / 100);
    }
  });

  return updatedRangeSensitivity;
};

export default customReverseParser;
